module.exports = __webpack_public_path__ + "media/images/pic/news-main-0dca6d6ff20384d4b5795b5dbd4bb157.jpg";